/**
 * Header scroll shadow handler
 * Adds/removes drop shadow on mobile header based on scroll position
 */
class HeaderScrollShadow {
    private static readonly HEADER_SELECTOR: string = '.mcp-header-mobile';
    private static readonly SHADOW_CLASS: string = '-scrolled';

    private header: HTMLElement | null = null;
    private headerHeight: number = 0;
    private isScrolled: boolean = false;
    private throttleTimeout: number | null = null;

    constructor() {
        this.init();
    }

    private init(): void {
        // Find the header element
        this.header = document.querySelector(
            HeaderScrollShadow.HEADER_SELECTOR
        );

        if (!this.header) {
            return; // Header not found, nothing to do
        }

        // Get the header height
        this.headerHeight = this.header.offsetHeight;

        // Set up scroll listener with throttling for performance
        window.addEventListener('scroll', this.handleScroll.bind(this), {
            passive: true
        });

        // Check initial scroll position in case page loads scrolled
        this.checkScrollPosition();
    }

    private handleScroll(): void {
        // Throttle scroll events for better performance
        if (this.throttleTimeout) {
            return;
        }

        this.throttleTimeout = window.setTimeout(() => {
            this.checkScrollPosition();
            this.throttleTimeout = null;
        }, 16); // ~60fps
    }

    private checkScrollPosition(): void {
        if (!this.header) {
            return;
        }

        const scrollY = window.scrollY || document.documentElement.scrollTop;
        const shouldShowShadow = scrollY >= this.headerHeight;

        if (shouldShowShadow && !this.isScrolled) {
            this.addShadow();
        } else if (!shouldShowShadow && this.isScrolled) {
            this.removeShadow();
        }
    }

    private addShadow(): void {
        if (this.header) {
            this.header.classList.add(HeaderScrollShadow.SHADOW_CLASS);
            this.isScrolled = true;
        }
    }

    private removeShadow(): void {
        if (this.header) {
            this.header.classList.remove(HeaderScrollShadow.SHADOW_CLASS);
            this.isScrolled = false;
        }
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Only initialize if mobile header exists
    if (document.querySelector('.mcp-header-mobile')) {
        new HeaderScrollShadow();
    }
});
